// extracted by mini-css-extract-plugin
export default {"project-box":"projectCard_project-box__-tfZc","secondary":"projectCard_secondary__W35ik","new-project":"projectCard_new-project__LuE7k"};